import { render, staticRenderFns } from "./ModalCollectionRename.vue?vue&type=template&id=159edd96&scoped=true"
import script from "./ModalCollectionRename.vue?vue&type=script&lang=js"
export * from "./ModalCollectionRename.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159edd96",
  null
  
)

export default component.exports